<template>
  <b-card>
    <b-row>
      <b-col>
        <filtro-configuravel
          v-for="(item, $index) in filtros"
          :key="$index"
          :value="item"
          :quantidade-itens="filtros.length"
          @adicionar="adicionar()"
          @remover="remover($event)"
        />
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col cols="auto">
        <b-dropdown
          text="Exportar"
          variant="primary"
          class="mr-1"
          size="sm"
          :disabled="!dados.length > 0"
        >
          <b-dropdown-item-btn
            class="dropButton"
            @click="exportarPlanilha"
          >
            Planilha
          </b-dropdown-item-btn>
        </b-dropdown>
        <b-btn
          variant="none"
          class="btn-primary btn-sm mr-50"
          @click.prevent.stop="limpar()"
        >Limpar</b-btn>
        <b-btn
          variant="none"
          class="btn-primary btn-sm"
          @click="aplicar()"
        >Aplicar</b-btn>
      </b-col>
    </b-row>
    <b-row class="mt-1">
      <b-col cols="12">
        <vue-good-table
          v-if="showTable"
          :rows="dados"
          :columns="colunasCopia"
          :pagination-options="{
            enabled: true,
            perPage: 10,
          }"
          :sort-options="{
            enabled: false,
          }"
        >
          <template
            slot="table-row"
            slot-scope="props"
          >
            <span
              v-if="props.column.field === 'nomeEmpresa'"
              style="font-size: 14px;"
            >
              <div class="tag-cadastro-federal">
                <span style="margin-right: 0.2rem;">
                  {{ props.row.CadastroFederal }}
                </span>
              </div>
              {{ props.row.RazaoSocial }}
            </span>
            <span
              v-else-if="props.column.field === 'Modelo'"
              :class="[{'sem-dados': !props.row.Modelo}]"
            >
              <span v-if="props.row.Modelo">{{ props.row.Modelo.Descricao }}</span>
              <p
                v-else
                class="linha-dado"
              />
            </span>
            <span
              v-else-if="props.column.field === 'Enquadramento'"
              :class="[{'sem-dados': !props.row.Enquadramento}]"
            >
              <span v-if="props.row.Enquadramento">{{ props.row.Enquadramento.Nome }}</span>
              <p
                v-else
                class="linha-dado"
              />
            </span>
            <span
              v-else-if="props.column.field === 'Equipe'"
              :class="[{'sem-dados': !props.row.Equipe}]"
            >
              <span v-if="props.row.Equipe">{{ props.row.Equipe.Nome }}</span>
              <p
                v-else
                class="linha-dado"
              />
            </span>
            <div
              v-else-if="props.column.field === 'CNAE'"
              style="display: inline-flex;"
            >
              <span
                v-if="props.row.CNAEPrincipal"
                class="cnae-badge"
              >
                {{ props.row.CNAEPrincipal.IdIBGE }}
              </span>
              <span
                v-for="(cnae, $index) in props.row.CNAESecundarios"
                :key="$index"
                class="cnae-badge"
              >
                {{ cnae.CNAE.IdIBGE }}
              </span>
            </div>
            <span
              v-else-if="props.column.field === 'Contato'"
              :class="[{'sem-dados': props.row.Contatos.length === 0}]"
            >
              <div
                v-if="props.row.Contatos.length > 0"
                style="display: inline-flex;"
              >
                <span
                  v-for="(usuario, $index) in props.row.Contatos"
                  :key="$index"
                  class="cnae-badge"
                >
                  {{ usuario.UsuarioExterno.NomeCompleto }}
                </span>
              </div>
              <p
                v-else
                class="linha-dado"
              />
            </span>
            <div
              v-else-if="props.column.field === 'Responsavel'"
              :class="[{'sem-dados': props.row.ResponsaveisDepartamentos.length === 0}]"
            >
              <div
                v-if="props.row.ResponsaveisDepartamentos.length > 0"
                style="display: inline-flex;"
              >
                <span
                  v-for="(responsavel, $index) in props.row.ResponsaveisDepartamentos"
                  :key="$index"
                  class="cnae-badge"
                >
                  {{ responsavel.UsuarioInterno.NomeCompleto }}
                </span>
              </div>
              <p
                v-else
                class="linha-dado"
              />
            </div>
            <span
              v-else-if="props.column.field === 'Socios'"
              :class="[{'sem-dados': props.row.Socios.length === 0}]"
            >
              <div
                v-if="props.row.Socios.length > 0"
                style="display: inline-flex;"
              >
                <span
                  v-for="(usuario, $index) in props.row.Socios"
                  :key="$index"
                  class="cnae-badge"
                >
                  {{ usuario.UsuarioExterno.NomeCompleto }}
                </span>
              </div>
              <p
                v-else
                class="linha-dado"
              />
            </span>
            <span
              v-else-if="props.column.field === 'EmailsBoletosNFs'"
              :class="[{'sem-dados': !props.row.EmailsBoletosNFs || props.row.EmailsBoletosNFs.length === 0}]"
            >
              <div
                v-if="props.row.EmailsBoletosNFs && props.row.EmailsBoletosNFs.length > 0"
                style="display: inline-flex;"
              >
                <span
                  v-for="(email, $index) in props.row.EmailsBoletosNFs.split(',')"
                  :key="$index"
                  class="cnae-badge"
                >
                  {{ email }}
                </span>
              </div>
              <p
                v-else
                class="linha-dado"
              />
            </span>
            <span v-else>
              {{ props.row[props.column.field].Nome }}
            </span>
          </template>
          <!-- no records -->
          <div slot="emptystate">
            <p style="text-align:center; margin:0">
              Nenhum registro foi encontrado.
            </p>
          </div>
          <!-- pagination -->
          <template
            slot="pagination-bottom"
            slot-scope="props"
          >
            <paginacao-base
              :valor="props"
              :quantidade="10"
            />
          </template>
        </vue-good-table>
      </b-col>
    </b-row>
    <a
      ref="download"
      download
      target="_blank"
      @click.stop
    />
  </b-card>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.dropButton button {
  width: 100% !important;
}

.cnae-badge{
  padding: 0rem 0.2rem;
  border-radius: 0.358rem;
  margin-right:0.3rem;
  background-color:transparent;
  border: 1px solid var(--primary) !important;
  color: var(--primary);
  height: 1.5rem;
  font-size: 12px;
  font-weight: 700;
}

.tag-cadastro-federal {
  & span {
    font-size: 0.65rem;
    color: var(--primary);
    font-weight: 700;
    background-color: transparent;
    border: 1px solid var(--primary) !important;
    border-radius: 2px;
    padding: 0.1rem 0.2rem;
  }
}

.tamanho-texto {
  font-size: 14px;
}

.linha-dado {
  padding-top: 1rem;border-bottom: 1px solid rgb(108 108 108 / 60%);
  width: 15%;
}

.sem-dados {
  display: flex;
  justify-content: center;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import api from '@/shared/components/consulta-configuravel/shared/services/api'

export default {
  name: 'ConsultaConfiguravelView',
  components: {
    VueGoodTable,
    PaginacaoBase: () => import('@/shared/components/paginacao-base/PaginacaoBase.vue'),
    FiltroConfiguravel: () => import('@/shared/components/consulta-configuravel/shared/components/FiltroConfiguravel.vue'),
  },
  data() {
    return {
      colunas: [
        { label: 'Empresa', field: 'nomeEmpresa' },
        {
          label: 'Enquadramento', field: 'Enquadramento', hidden: true, width: '230px', tdClass: 'tamanho-texto',
        },
        {
          label: 'CNAE', field: 'CNAE', hidden: true, width: '150px', tdClass: 'tamanho-texto',
        },
        {
          label: 'Equipe', field: 'Equipe', hidden: true, tdClass: 'tamanho-texto',
        },
        {
          label: 'UF - Endereço', field: 'UF', hidden: true, width: '180px', tdClass: 'tamanho-texto',
        },
        {
          label: 'Cidade', field: 'Cidade', hidden: true, tdClass: 'tamanho-texto',
        },
        {
          label: 'Modelo', field: 'Modelo', hidden: true, width: '340px', tdClass: 'tamanho-texto',
        },
        {
          label: 'Usuário - contato', field: 'Contato', hidden: true, width: '240px', tdClass: 'tamanho-texto',
        },
        {
          label: 'Usuário - responsável', field: 'Responsavel', hidden: true, width: '250px', tdClass: 'tamanho-texto',
        },
        {
          label: 'Sócios', field: 'Socios', hidden: true, width: '250px', tdClass: 'tamanho-texto',
        },
        {
          label: 'E-mail para Recebimento de Boletos e Notas Fiscais', field: 'EmailsBoletosNFs', hidden: true, width: '250px', tdClass: 'tamanho-texto',
        },
      ],
      dados: [],
      filtros: [],
      showTable: false,
      colunasCopia: [],
    }
  },
  created() {
    this.filtros.push({
      opcaoSelecionada: null,
      semConfiguracao: false,
      filtrosValores: [],
      code: this.getCode(),
    })
  },
  methods: {
    getCode() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2)
    },
    limpar() {
      this.filtros = []
      this.filtros.push({
        opcaoSelecionada: null,
        semConfiguracao: false,
        filtrosValores: [],
        code: this.getCode(),
      })
      this.dados = []
      this.showTable = false
    },
    aplicar() {
      this.showTable = false
      this.colunasCopia = JSON.parse(JSON.stringify(this.colunas))
      this.montarGrid()
    },
    montarGrid() {
      this.$isLoading(true)
      api.getEmpresasConfiguradas(this.filtros)
        .then(payload => {
          this.filtros.forEach(each => {
            const coluna = this.colunasCopia.find(fin => fin.field === each.opcaoSelecionada)
            if (coluna) {
              coluna.hidden = false
            }
          })
          this.dados = payload.data
          this.showTable = true
          this.$isLoading(false)
        })
        .catch(err => {
          this.$isLoading(false)
          this.$handleError(err)
        })
    },
    adicionar() {
      this.filtros.push({
        opcaoSelecionada: null,
        semConfiguracao: false,
        filtrosValores: [],
        code: this.getCode(),
      })
    },
    remover(code) {
      const index = this.filtros.findIndex(find => find.code === code)
      this.filtros.splice(index, 1)
    },
    exportarPlanilha() {
      this.$isLoading(true)
      api.exportAsExcel(this.filtros)
        .then(payload => {
          this.$refs.download.href = payload.data.url
          this.$refs.download.click()
          this.$isLoading(false)
          setTimeout(() => {
            api.deleteExcel(payload.data.fileName)
          }, 3000)
        })
        .catch(() => {
          this.$isLoading(false)
        })
    },
  },
}
</script>
